import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import FullCard from '../../../../components/Card/FullCard';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useHistory } from 'react-router-dom';
import useRules from '../../../../hooks/useRules';
import useTitle from 'hooks/useTitle';

const Calculations = (props) => {
  useTitle('محاسبات')
  const history = useHistory();
  const [rules,hasRule,isAdmin] = useRules();
  const allChilds = props.config.childs;
  return (
    <FullCard title={props.config.name}>
      <List>
        {allChilds.filter(r=>hasRule(r.slug)).map((r, i) => {
          return (
            <ListItem key={i} button>
              <ListItemText
                onClick={() => history.push(`/protected/admin${r.path}`)}
              >
                {r.name}
              </ListItemText>
            </ListItem>
          );
        })}
      </List>
    </FullCard>
    // <div className="content">
    //   <Grid fluid>
    //     <Row>
    //       <Col md={12}>
    //         <Card
    //           title={props.config.name}
    //           category={"مدیریت کلیه پارامترهای موثر در محاسبات قیمت"}
    //           content={
    //             <ul className="main-section-menu">
    //               {allChilds
    //                 .filter(route =>
    //                   route.role.find(role => roles.includes(role))
    //                 )
    //                 .map((r, i) => {
    //                   return (
    //                     <li key={i}>
    //                       <Link to={`/protected/admin${r.path}`}>{r.name}</Link>
    //                     </li>
    //                   );
    //                 })}
    //             </ul>
    //           }
    //         />
    //       </Col>
    //     </Row>
    //   </Grid>
    // </div>
  );
};

export default Calculations;
